import { render, staticRenderFns } from "./IngestTable.vue?vue&type=template&id=ef7dd2c2&scoped=true"
import script from "./IngestTable.vue?vue&type=script&lang=js"
export * from "./IngestTable.vue?vue&type=script&lang=js"
import style0 from "./IngestTable.vue?vue&type=style&index=0&id=ef7dd2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7dd2c2",
  null
  
)

export default component.exports